import API_BASE_URL from "../RestAPI";

const BASE = `${API_BASE_URL.replace(/\/$/, "")}/reminders`;

const getAuthHeaders = () => {
    const token = localStorage.getItem("authToken");
    const headers = { "Content-Type": "application/json" };
    if (token) headers.Authorization = `Bearer ${token}`;
    return headers;
};

export const remindersApi = {
    // Dashboard
    getDashboard: async () => {
        const res = await fetch(`${BASE}/dashboard/`, { method: "GET", headers: getAuthHeaders() });
        if (!res.ok) throw new Error(res.statusText || "Failed to fetch dashboard");
        return res.json();
    },

    // Categories
    getCategories: async () => {
        const res = await fetch(`${BASE}/category/`, { method: "GET", headers: getAuthHeaders() });
        if (!res.ok) throw new Error(res.statusText || "Failed to fetch categories");
        return res.json();
    },

    createCategory: async (payload) => {
        const res = await fetch(`${BASE}/category/`, {
            method: "POST", headers: getAuthHeaders(), body: JSON.stringify(payload),
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data.message || "Failed to create category");
        return data;
    },

    updateCategory: async (payload) => {
        const res = await fetch(`${BASE}/category/`, {
            method: "PUT", headers: getAuthHeaders(), body: JSON.stringify(payload),
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data.message || "Failed to update category");
        return data;
    },

    deleteCategory: async (id) => {
        const res = await fetch(`${BASE}/category/?id=${id}`, { method: "DELETE", headers: getAuthHeaders() });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data.message || "Failed to delete category");
        return data;
    },

    // Reminder Items
    getItems: async (params = {}) => {
        const query = new URLSearchParams(params).toString();
        const url = query ? `${BASE}/item/?${query}` : `${BASE}/item/`;
        const res = await fetch(url, { method: "GET", headers: getAuthHeaders() });
        if (!res.ok) throw new Error(res.statusText || "Failed to fetch reminders");
        return res.json();
    },

    getItem: async (id) => {
        const res = await fetch(`${BASE}/item/?id=${id}`, { method: "GET", headers: getAuthHeaders() });
        if (!res.ok) throw new Error(res.statusText || "Failed to fetch reminder");
        return res.json();
    },

    createItem: async (payload) => {
        const res = await fetch(`${BASE}/item/`, {
            method: "POST", headers: getAuthHeaders(), body: JSON.stringify(payload),
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data.message || "Failed to create reminder");
        return data;
    },

    updateItem: async (payload) => {
        const res = await fetch(`${BASE}/item/`, {
            method: "PUT", headers: getAuthHeaders(), body: JSON.stringify(payload),
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data.message || "Failed to update reminder");
        return data;
    },

    deleteItem: async (id) => {
        const res = await fetch(`${BASE}/item/?id=${id}`, { method: "DELETE", headers: getAuthHeaders() });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data.message || "Failed to delete reminder");
        return data;
    },

    // Renewals
    getRenewals: async (reminderId) => {
        const res = await fetch(`${BASE}/renewal/?reminder_id=${reminderId}`, { method: "GET", headers: getAuthHeaders() });
        if (!res.ok) throw new Error(res.statusText || "Failed to fetch renewals");
        return res.json();
    },

    recordRenewal: async (payload) => {
        const res = await fetch(`${BASE}/renewal/`, {
            method: "POST", headers: getAuthHeaders(), body: JSON.stringify(payload),
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data.message || "Failed to record renewal");
        return data;
    },

    // Bulk status refresh
    refreshStatuses: async () => {
        const res = await fetch(`${BASE}/bulk-status-update/`, { method: "POST", headers: getAuthHeaders(), body: JSON.stringify({}) });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data.message || "Failed to refresh statuses");
        return data;
    },
};
